export default "__VITE_ASSET__CrHIAeVO__"